export enum Tags {
  FrontLineWorkers = 'front-line-workers',
  AdultsAndYoungPeople = '12-14,15-17,18+',
  YoungPeoples = '12-14,15-17',
  AdultAnd1517 = '15-17,18+',
  AdultAnd1214 = '12-14,18+',
  NA = 'n/a',
  Unknown = 'unknown',
}